<template>
  <div id="Content">
    <div class="publishPreviewNav">
      <img src="../../../../img/previewLogo.png" alt="" />
      <span class="publishNavTitle">大百科</span>
    </div>
    <!-- 页面标题 -->
    <div class="contentBox" id="mediaContent">
      <div class="articleTitle">
        <p>{{ articleTitle }}</p>
      </div>
      <div class="basicInfo">
        <div class="moduleTitle">基本信息</div>
        <div class="basicContent">
          <div class="authorText" style="width: 100%">
            <p><span>路径：</span>{{ basicInfo.httpPath }}</p>
          </div>
          <div class="authorText">
            <p><span>分支：</span>{{ basicInfo.subjectInfo }}</p>
          </div>
          <div class="authorText">
            <p><span>许可期限：</span>{{ basicInfo.permitTime }}</p>
          </div>
          <div class="authorText">
            <p><span>关键字：</span>{{ basicInfo.word }}</p>
          </div>
          <div class="authorText">
            <p><span>来源：</span>{{ basicInfo.origin }}</p>
          </div>
          <div class="authorText">
            <p><span>版权：</span>{{ basicInfo.copyright }}</p>
          </div>
          <div class="authorText">
            <p><span>合同期限：</span>{{ basicInfo.contract }}</p>
          </div>
          <div class="authorText">
            <p><span>许可类型：</span>{{ basicInfo.permitType }}</p>
          </div>
          <div class="authorText">
            <p><span>许可范围：</span>{{ basicInfo.permitScope }}</p>
          </div>
          <div class="authorText">
            <p><span>资源类别：</span>{{ basicInfo.resourceType }}</p>
          </div>
          <div class="authorText">
            <p><span>来源方式：</span>{{ basicInfo.dealtype }}</p>
          </div>

          <div class="imgInfo" v-if="currentType == 1" style="width: 100%">
            <div class="authorText">
              <p><span>图片大小：</span>{{ basicInfo.imageRatio }}</p>
            </div>
            <div class="authorText">
              <p><span>图注：</span>{{ basicInfo.imageNote }}</p>
            </div>
          </div>
          <div class="videoInfo" v-if="currentType == 2" style="width: 100%">
            <div class="authorText">
              <p><span>系列题名：</span>{{ basicInfo.videoSeriesTitle }}</p>
            </div>
            <div class="authorText">
              <p><span>分集数：</span>{{ basicInfo.videoDiversityTotal }}</p>
            </div>
            <div class="authorText">
              <p><span>色彩：</span>{{ basicInfo.videoColor }}</p>
            </div>
            <div class="authorText">
              <p><span>时代：</span>{{ basicInfo.videoPeriod }}</p>
            </div>
            <div class="authorText">
              <p><span>视频声道语种：</span>{{ basicInfo.videoVoice }}</p>
            </div>
            <div class="authorText" style="width: 100%">
              <p><span>字幕：</span>{{ basicInfo.videoCaption }}</p>
            </div>
          </div>
          <div class="videoInfo" v-if="currentType == 3" style="width: 100%">
            <div class="authorText">
              <p><span>音频语种：</span>{{ basicInfo.audioLanguage }}</p>
            </div>
            <div class="authorText">
              <p><span>作词：</span>{{ basicInfo.audioWordAuthor }}</p>
            </div>
            <div class="authorText">
              <p><span>作曲：</span>{{ basicInfo.audioComposeAuthor }}</p>
            </div>
            <div class="authorText">
              <p><span>演唱者：</span>{{ basicInfo.audioSinger }}</p>
            </div>
            <div class="authorText">
              <p><span>演奏：</span>{{ basicInfo.audioExecutant }}</p>
            </div>
            <div class="authorText">
              <p><span>专辑：</span>{{ basicInfo.audioAlbum }}</p>
            </div>
            <div class="authorText">
              <p><span>比特率：</span>{{ basicInfo.audioBitRate }}</p>
            </div>
            <div class="authorText">
              <p><span>采样率：</span>{{ basicInfo.audioSamplingRate }}</p>
            </div>
            <div class="authorText">
              <p><span>时长：</span>{{ basicInfo.audioTimeLong }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="description">
        <div class="moduleTitle">描述</div>
        <div class="descTextContent"></div>
      </div>
      <div class="relatedResource">
        <div class="moduleTitle">关联资源</div>
        <div class="relatedContent">
          <el-table :data="relatedResourceData" style="width: 100%" border>
            <el-table-column prop="name" label="资源名称" width="150">
            </el-table-column>
            <el-table-column prop="subBranch" label="资源路径">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="description" v-if="currentType == 2&&menuData.length>0">
        <div class="moduleTitle">课程目录</div>
        <div class="menuContent"></div>
        <el-tree
          ref="tree"
          :props="props"
          :data="menuData"
          :default-expand-all="true"
          highlight-current
          node-key="id"
        >
        </el-tree>
      </div>
      <div class="basicInfo zjrInfo" v-if="!isZjrInfoEmpty">
        <div class="moduleTitle">主讲人信息</div>
        <div class="basicContent">
          <div class="authorText" v-if="zjrInfo.zjr">
            <p><span>主讲人：</span>{{ zjrInfo.zjr }}</p>
          </div>
          <div class="authorText" v-if="zjrInfo.zjrdw">
            <p><span>主讲人单位：</span>{{ zjrInfo.zjrdw }}</p>
          </div>
        </div>
      </div>
      <div class="zjrjj" v-if="zjrjj != ''">
        <div class="moduleTitle">主讲人简介</div>
        <div class="zjrjjContent"></div>
      </div>
      <div class="wzg" v-if="wzg != ''">
        <div class="moduleTitle">文字稿</div>
        <div class="wzgContent"></div>
      </div>
      <div class="mainContent">
        <div class="moduleTitle">多媒体内容</div>
        <div class="previewContent">
          <div class="imgPreviewBox" v-if="currentType == 1">
            <img class="previewImg" :src="imgUrl" />
            <p>{{ articleTitle }}</p>
          </div>
          <div class="imgPreviewBox" v-if="currentType == 2">
            <video class="previewVideo" controls>
              <source :src="videoUrl" type="video/mp4" />
            </video>
            <p>{{ articleTitle }}</p>
          </div>
          <div class="imgPreviewBox" v-if="currentType == 3">
            <audio controls style="width: 50%">
              <source :src="audioUrl" type="audio/mp3" />
            </audio>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data() {
    return {
      data: [],
      menuData: [],
      relatedResourceData: [],
      articleTitle: "",
      wzg: "",
      zjrjj: "",
      currentType: 1,

      basicInfo: {},
      zjrInfo: {},
      isbasicInfoEmpty: false,
      isZjrInfoEmpty: false,
      imageNote: "",
      //   authorText: "",
      //   sourceInfo: "",
      description: "",
      //   headTextList: [],
      //   summaryFieldsList: [],

      imgUrl: "",
      videoUrl: "",
      audioUrl: "",
      props: {
        label: "name",
        children: "children",
        isLeaf: "leaf",
      },
    };
  },
  props: {
    topIndex: String,
  },
  mounted() {
    let that = this;
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    $.ajax({
      type: "GET",
      dataType: "json",
      url: "/zyk/resource/preview",
      data: { id: this.$route.query.id },
      contentType: "application/json;charset=utf-8",
      success: function (response) {
        if (response.code == 200) {
          console.log(response);
          var data = response.obj;
          that.currentType = data.type;
          that.basicInfo = {
            httpPath: data.httpPath,
            permitTime: data.resourceInfoExtend.permitTime,
            word: data.resourceInfoExtend.word,
            origin: data.resourceInfoExtend.origin,
            copyright: data.resourceInfoExtend.copyright,
            contract: data.resourceInfoExtend.contract,
            permitType: data.resourceInfoExtend.permitType,
            permitScope: data.resourceInfoExtend.permitScope,
            resourceType: data.resourceInfoExtend.resourceType,
            dealtype: data.resourceInfoExtend.dealtype,
            imageRatio: data.resourceInfoExtend.imageRatio,
            imageNote: data.resourceInfoExtend.imageNote,
            videoSeriesTitle: data.resourceInfoExtend.videoSeriesTitle,
            videoDiversityTotal: data.resourceInfoExtend.videoDiversityTotal,
            videoColor: data.resourceInfoExtend.videoColor,
            videoPeriod: data.resourceInfoExtend.videoPeriod,
            videoVoice: data.resourceInfoExtend.videoVoice,
            videoCaption: data.resourceInfoExtend.videoCaption,
            audioLanguage: data.resourceInfoExtend.audioLanguage,
            audioWordAuthor: data.resourceInfoExtend.audioWordAuthor,
            audioComposeAuthor: data.resourceInfoExtend.audioComposeAuthor,
            audioSinger: data.resourceInfoExtend.audioSinger,
            audioExecutant: data.resourceInfoExtend.audioExecutant,
            audioAlbum: data.resourceInfoExtend.audioAlbum,
            audioBitRate: data.resourceInfoExtend.audioBitRate,
            audioSamplingRate: data.resourceInfoExtend.audioSamplingRate,
            audioTimeLong: data.resourceInfoExtend.audioTimeLong,
          };

          if (data.resourceInfoExtend.description != null) {
            that.description = data.resourceInfoExtend.description;
            setTimeout(function () {
              $(".descTextContent").html(data.resourceInfoExtend.description);
            }, 2000);
          }
          if (data.resourceInfoExtend.menu != null) {
            that.menuData = JSON.parse(data.resourceInfoExtend.menu).children;
          }

          if (data.resourceInfoExtend.zjrjj != null) {
            that.zjrjj = data.resourceInfoExtend.zjrjj;
            setTimeout(function () {
              $(".zjrjjContent").html(data.resourceInfoExtend.zjrjj);
            }, 2000);
          }
          if (data.resourceInfoExtend.wzg != null) {
            that.wzg = data.resourceInfoExtend.wzg;
            setTimeout(function () {
              $(".wzgContent").html(data.resourceInfoExtend.wzg);
            }, 2000);
          }
          that.articleTitle = data.title;
          //   that.sourceInfo = data.sourceInfo.name;
          if (data.subjectInfo != null) {
            that.basicInfo.subjectInfo = data.subjectInfo.subBranch;
          }

          if (data.resourceInfoExtend.zjr != null) {
            that.zjrInfo.zjr = data.resourceInfoExtend.zjr;
          }
          if (data.resourceInfoExtend.zjrdw != null) {
            that.zjrInfo.zjrdw = data.resourceInfoExtend.zjrdw;
          }

          if (data.wordInfos != []) {
            for (var i = 0; i < data.wordInfos.length; i++) {
              that.relatedResourceData.push({
                name: data.wordInfos[i].name,
                subBranch: data.wordInfos[i].subjectInfo.subBranch,
              });
            }
          }

          that.imgUrl = data.httpPath;
          that.imageNote = data.resourceInfoExtend.imageNote;
          that.videoUrl = data.httpPath;
          that.audioUrl = data.httpPath;

          that.isbasicInfoEmpty = $.isEmptyObject(that.basicInfo);
          that.isZjrInfoEmpty = $.isEmptyObject(that.zjrInfo);

          setTimeout(function () {
            var pWidth = $(".imgPreviewBox img").width();
            $(".imgPreviewBox p").width(pWidth);
          }, 1000);
        } else {
          that.$message({
            message: response.msg,
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      },
      error: function (data) {
        console.log(data);
      },
    });
  },
  methods: {
    getChild() {
      console.log(this.index);
    },
    changePlayStatus(status) {
      //获取子组件的播放状态
      if (status) {
        this.disabledShot = false;
      } else {
        this.disabledShot = true;
        this.sourceUrl = "";
        this.checkedPontsName = "";
      }
    },
  },
};
</script>

<style>
#mediaContent .previewContent {
  text-align: center;
}

#mediaContent .previewVideo {
  width: 100%;
}

.pageTitle {
  line-height: 100px;
  color: #fff;
  font-size: 24px;
  padding-left: 100px !important;
  background: #666;
  height: auto !important;
}

/* #Content .contentBox {
  padding: 0 20%;
} */

#Content .contentBox .articleTitle p {
  font-size: 40px;
  padding: 20px 0;
  color: #000;
  font-weight: bolder;
}

#Content .contentBox .previewContent p {
  /* line-height: 2.5em; */
  font-size: 16px;
}
/* #Content .contentBox .previewContent {
  padding: 20px 0;
} */

#Content .contentBox .moduleTitle {
  font-size: 22x;
  font-weight: bolder;
  border-bottom: 1px solid rgba(35, 77, 60, 0.4);
  color: #295a46;
  padding-bottom: 10px;
  margin-bottom: 20px;
  margin-top: 30px;
}

#Content .contentBox .mainContent {
  margin-top: 20px;
  margin-bottom: 50px;
}

#Content .contentBox .basicInfo .basicContent {
  overflow: auto;
}

#Content .contentBox .basicInfo .basicContent::after {
  content: "";
  display: inline-block;
  clear: both;
}

#Content .contentBox .basicInfo .basicContent div {
  float: left;
  width: 50%;
  margin-bottom: 20px;
}

#Content .contentBox .basicInfo .basicContent p span {
  font-weight: bolder;
}

.infoText {
  overflow: auto;
}

.infoText::after {
  content: "";
  display: inline-block;
  clear: both;
}

.infoText p {
  float: left;
  width: 50%;
  margin-bottom: 20px;
}

.infoText p span {
  font-weight: bolder;
}

.imgPreviewBox p {
  border: 1px solid #dcdfe6;
  border-bottom: 2px solid #50b58d;
  margin: 0 auto;
  margin-top: -5px;
}

.wzgContent,
.zjrjjContent {
  text-indent: 2em;
  line-height: 2.1em;
}
</style>
